<template>
  <v-container class="formulario-wrapper pt-6" fluid style="background-color: #f4f7f6; min-height: 80vh;">
    <v-card class="elevation-2">

      <v-card-text>
        <v-form ref="form">

          <div class="d-flex align-center mt-3 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-package-variant-closed</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              PRODUTO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>

          <v-row align="center">
            <v-col cols="4" sm="2">
              <v-text-field 
                v-model="formData.idProduto" 
                label="Código" 
                outlined dense hide-details type="number" 
                :error="['Produto não encontrado', 'Erro no Banco'].includes(formData.nomeProduto)"
              ></v-text-field>
            </v-col>
            <v-col cols="1" sm="1" class="d-flex justify-center">
              <v-btn fab small color="primary" elevation="1" @click="pesquisarProduto">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="7" sm="9">
              <v-text-field 
                v-model="formData.nomeProduto" 
                label="Produto" 
                outlined dense hide-details readonly background-color="#FFF9C4"
                :error="['Produto não encontrado', 'Erro no Banco'].includes(formData.nomeProduto)"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" md="4">
              <v-text-field
                v-model="formData.quantidadeProduto"
                label="Quantidade"
                outlined dense hide-details type="number"
                @focus="limparZeroQuantidade"
                @blur="restaurarZeroQuantidade"
              ></v-text-field>
            </v-col>
            <v-col cols="4" md="4">
              <v-text-field
                v-model="precoProdutoFormatado"
                label="Preço"
                outlined dense hide-details
                inputmode="numeric"
                @keypress="permitirApenasNumeros"
              ></v-text-field>
            </v-col>
            <v-col cols="4" md="4">
              <v-text-field
                :value="totalProdutoFormatado"
                label="Total"
                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
          </v-row>

          <template v-if="exibirSecaoTecnicos">
            <div class="d-flex align-center mt-3 mb-2">
              <v-icon small color="primary" class="mr-2">mdi-account-hard-hat </v-icon>
              <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
                TÉCNICOS
              </span>
              <v-divider class="ml-3 divisor-secao"></v-divider>
            </div>

            <v-row v-for="(tecnico, index) in formData.tecnicos" :key="index" class="mb-2 mt-1 align-center">
              <v-col cols="4" sm="2" class="py-0">
                <v-text-field 
                  v-model="tecnico.codTecnico" 
                  :label="`Código ${formData.tecnicos.length > 1 ? (index + 1) : ''}`.trim()" 
                  outlined dense hide-details type="number" 
                  @input="onTecnicoInput($event, index)"
                  :error="['Técnico não encontrado', 'Erro no Banco'].includes(tecnico.nome)">
                </v-text-field>
              </v-col>
              <v-col cols="1" sm="1" class="d-flex justify-center py-0">
                <v-btn fab small color="primary" elevation="1" @click="pesquisarTecnico(index)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="7" sm="9" class="py-0">
                <v-text-field 
                  v-model="tecnico.nome" 
                  :label="`Nome ${formData.tecnicos.length > 1 ? (index + 1) : ''}`.trim()" 
                  outlined dense hide-details readonly background-color="#FFF9C4"
                  :error="['Técnico não encontrado', 'Erro no Banco'].includes(tecnico.nome)">
                </v-text-field>
              </v-col>
              
              <v-row class="mb-2 mt-2 px-3" justify="end" align="center">
                <v-col cols="4" class="py-0">
                  <v-text-field 
                    :value="formatarMoedaArray(tecnico.valor)" 
                    @input="val => atualizarValorTecnico(val, index)"
                    label="Valor" 
                    outlined dense hide-details
                    :readonly="!podeEditarValorTecnico"
                    :background-color="!podeEditarValorTecnico ? '#FFF9C4' : undefined"
                    inputmode="numeric"
                    @keypress="permitirApenasNumeros">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-row>
          </template>

          <template v-if="exibirSecaoTecnicoRetirouPeca">
            <div class="d-flex align-center mt-3 mb-2">
              <v-icon small color="primary" class="mr-2">mdi-account-remove-outline</v-icon>
              <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
                TÉCNICO QUE RETIROU A PEÇA
              </span>
              <v-divider class="ml-3 divisor-secao"></v-divider>
            </div>

            <v-row align="center" class="mb-2 mt-1">
              <v-col cols="4" sm="2" class="py-0">
                <v-text-field 
                  v-model="formData.codTecnicoRetirouPeca" 
                  label="Código" 
                  outlined dense hide-details type="number" 
                  @input="onTecnicoRetirouPecaInput($event)"
                  :error="['Técnico não encontrado', 'Erro no Banco'].includes(formData.nomeTecnicoRetirouPeca)">
                </v-text-field>
              </v-col>
              <v-col cols="1" sm="1" class="d-flex justify-center py-0">
                <v-btn fab small color="primary" elevation="1" @click="pesquisarTecnicoRetirouPeca">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="7" sm="9" class="py-0">
                <v-text-field 
                  v-model="formData.nomeTecnicoRetirouPeca" 
                  label="Nome do Técnico" 
                  outlined dense hide-details readonly background-color="#FFF9C4"
                  :error="['Técnico não encontrado', 'Erro no Banco'].includes(formData.nomeTecnicoRetirouPeca)">
                </v-text-field>
              </v-col>
            </v-row>
          </template>

          <v-divider class="my-4 divisor-secao"></v-divider>

          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="formData.defeitoApresentado"
                label="Observação"
                outlined
                hide-details
                rows="3"
                background-color="lighten-5"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="divisor-secao"></v-divider>

      <v-card-actions class="pa-4">
        <v-row>
          <v-col cols="4" class="text-left">
            <v-btn color="error" outlined @click="excluir" v-if="pedidoDexieId && !priidnuvem">Excluir</v-btn>
          </v-col>
          <v-col cols="4" class="text-center">
            <v-btn text @click="cancelar" outlined>Cancelar</v-btn>
          </v-col>
          <v-col cols="4" class="text-right">
            <v-btn color="primary" @click="salvar">Salvar</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogValidacao" max-width="400">
      <v-card>
        <v-card-title class="headline primary white--text text--darken-2">
          Atenção
        </v-card-title>
        
        <v-card-text class="pt-4 body-1 black--text">
          Não foi possível salvar. Verifique os seguintes itens:
          
          <ul class="mt-3 ml-2">
            <li v-for="(campo, index) in camposInvalidos" :key="index" class="red--text text--darken-3">
              {{ campo }}
            </li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogValidacao = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogExclusao" max-width="400">
      <v-card>
        <v-card-title class="headline primary white--text">
          Confirmar Exclusão
        </v-card-title>
        
        <v-card-text class="pt-4 body-1 black--text">
          Tem certeza que deseja excluir este item?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text outlined @click="dialogExclusao = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="confirmarExclusao">
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import db from '@/plugins/dexie';
import { USER_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'CadastroOS',
    components: {

  },
  data() {
    return {
      debounceProduto: null,
      debounceTecnicoRetirouPeca: null,
      veioDaPesquisa: false,
      debounceTecnicos: {},
      pedidoDexieId: null,
      priidnuvem: null,
      dialogValidacao: false,
      dialogExclusao: false,
      camposInvalidos: [],
      isServico: false,

      prilinkpedidoitem: null,
      
      formData: {
        nroOS: null,
        dataAbertura: new Date().toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }),
        dataAbertura2: new Date().toISOString().substr(0, 10),
        dataFechamento: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().substr(0, 10),
        idEmpresa: null,
        nomeEmpresa: null,
        cliente: null,
        nomeCliente: null,
        placa: null,
        contato: null,
        recebidoPor: null,
        idGrupo: null,
        
        idProduto: null, 
        nomeProduto: null, 

        idVendedor: null, 
        nomeVendedor: null, 
        idFornecedor: null,
        nomeFornecedor: null,
        idTecnicoRetirouPeca: '',
        codTecnicoRetirouPeca: '',
        nomeTecnicoRetirouPeca: '',

        quantidadeProduto: 0,
        precoProduto: 0,
        totalProduto: 0,
        tecnicos: [
          { codTecnico: '', idtecnico: '', nome: '', valor: '' }
        ]
      },
    }
  },

  mounted() {
    this.ajustarQuantidadeTecnicos();
    this.verificarRetornoPesquisa();
  },
  activated() {
    this.ajustarQuantidadeTecnicos();
    this.verificarRetornoPesquisa();
  },

  computed: {
    qtdeTecnicosOS() {
      const val = this.$store.getters['empresa/qtdeTecnicosOS'];
      const num = parseInt(val);
      return !isNaN(num) && num > 0 ? (num > 3 ? 3 : num) : 1;
    },

    pedeTecnicoRetirouPeca() {
      const val = this.$store.getters['empresa/pedeTecnicoRetirouPeca'];
      return val ? String(val).toUpperCase().trim() : 'N';
    },

    exibirSecaoTecnicoRetirouPeca() {
      return this.pedeTecnicoRetirouPeca === 'S';
    },

    pedeTecnicoItemOS() {
      const val = this.$store.getters['empresa/pedeTecnicoItemOS'];
      if (!val) return 'N';
      const strVal = String(val).toUpperCase().trim();
      if (['T', 'P', 'S', 'N'].includes(strVal)) {
        return strVal;
      }
      if (['SIM', 'TRUE', '1'].includes(strVal)) {
        return 'T';
      }
      return 'N';
    },

    exibirSecaoTecnicos() {
      const param = this.pedeTecnicoItemOS;
      if (param === 'T') return true;
      if (param === 'P') return !this.isServico;
      if (param === 'S') return this.isServico;
      return false;
    },

    pedeValorTecnicoItemOS() {
      const val = this.$store.getters['empresa/pedeValorTecnicoItemOS'];
      return val ? String(val).toUpperCase().trim() : 'N';
    },

    podeEditarValorTecnico() {
      return this.pedeValorTecnicoItemOS === 'S';
    },

    precoProdutoFormatado: {
      get() {
        const valor = parseFloat(this.formData.precoProduto) || 0;
        return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      set(novoValor) {
        const apenasNumeros = novoValor.toString().replace(/\D/g, '');
        this.formData.precoProduto = apenasNumeros ? (parseFloat(apenasNumeros) / 100) : 0;
      }
    },

    totalProdutoFormatado() {
      const valor = parseFloat(this.formData.totalProduto) || 0;
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  },

  methods: {
    ajustarQuantidadeTecnicos() {
      const targetCount = this.qtdeTecnicosOS;
      if (!this.formData.tecnicos) {
        this.formData.tecnicos = [];
      }
      while (this.formData.tecnicos.length < targetCount) {
        this.formData.tecnicos.push({ codTecnico: '', idtecnico: '', nome: '', valor: '' });
      }
      if (this.formData.tecnicos.length > targetCount) {
        this.formData.tecnicos.splice(targetCount);
      }
    },

    onTecnicoInput(valor, index) {
      if (!valor) {
        this.$set(this.formData.tecnicos[index], 'nome', '');
        this.$set(this.formData.tecnicos[index], 'idtecnico', '');
        return;
      }

      clearTimeout(this.debounceTecnicos[index]);
      this.debounceTecnicos[index] = setTimeout(() => {
        this.buscarTecnico(valor, index);
      }, 400);
    },

    async obterProdutoPorCodigo(valor) {
      if (!valor) return null;
      const idNum = parseInt(valor);
      const strVal = String(valor).trim();
      
      try {
        let produto = await db.produto.where('proidnuvem').equals(strVal).first();
        if (!produto && !isNaN(idNum)) {
          produto = await db.produto.where('proidnuvem').equals(idNum).first();
        }
        if (!produto) {
          produto = await db.produto.where('procodigointerno').equals(strVal).first();
        }
        if (!produto && !isNaN(idNum)) {
          produto = await db.produto.where('procodigointerno').equals(idNum).first();
        }
        if (!produto) {
          produto = await db.produto.filter(p => 
            String(p.proidcortamanhofinal) === strVal || 
            String(p.idcortamanhofinal) === strVal ||
            (!isNaN(idNum) && (p.proidcortamanhofinal === idNum || p.idcortamanhofinal === idNum))
          ).first();
        }
        return produto;
      } catch (e) {
        console.error("Erro ao obter produto por código:", e);
        return null;
      }
    },

    async verificarSeEhServico(idProduto, idGrupo = null) {
      if (!idProduto) {
        this.isServico = false;
        return;
      }
      try {
        let produto = await this.obterProdutoPorCodigo(idProduto);

        let catId = null;
        let grupoId = idGrupo;

        if (produto) {
          if (produto.proidgrupo || produto.idgrupo) {
            grupoId = produto.proidgrupo || produto.idgrupo;
          }
          if (produto.proidcategoriaproduto || produto.idcategoriaproduto) {
            catId = produto.proidcategoriaproduto || produto.idcategoriaproduto;
          }
        }

        if (catId) {
          const catIdNum = parseInt(catId);
          let cat = null;
          if (!isNaN(catIdNum)) {
            cat = await db.categoria.where('catidcategoria').equals(catIdNum).first();
          }
          if (!cat) {
            cat = await db.categoria.where('catidcategoria').equals(String(catId)).first();
          }
          if (!cat && !isNaN(catIdNum)) {
            cat = await db.categoria.get(catIdNum);
          }

          if (cat && cat.catservico !== undefined && cat.catservico !== null) {
            this.isServico = (cat.catservico === 1 || cat.catservico === true || String(cat.catservico).toUpperCase() === 'S' || String(cat.catservico) === '1');
            return;
          }
        }

        const grupoNum = parseInt(grupoId);
        this.isServico = (grupoNum === 2);
      } catch (err) {
        console.error('Erro ao verificar se item é serviço:', err);
        const grupoNum = parseInt(idGrupo);
        this.isServico = (grupoNum === 2);
      }
    },

    async buscarProduto(valor) {
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.formData.nomeProduto = '';
        this.formData.idGrupo = null;
        this.isServico = false;
        return;
      }
      
      try {
        let produto = await this.obterProdutoPorCodigo(valor);

        if (produto) {
          this.formData.nomeProduto = produto.prodescricao || produto.descricao;
          this.formData.idGrupo = produto.proidgrupo || produto.idgrupo || produto.idGrupo || null;
          
          const valorProd = produto.provalor || produto.propreco || produto.preco || 0;
          if (valorProd) {
            this.formData.precoProduto = Number(valorProd);
          }

          if (!this.formData.quantidadeProduto || this.formData.quantidadeProduto == 0) {
            this.formData.quantidadeProduto = 1;
          }
          
        } else {
          this.formData.nomeProduto = 'Produto não encontrado';
          this.formData.idGrupo = null;
        }

        await this.verificarSeEhServico(valor, this.formData.idGrupo);
      } catch (error) {
        console.error("Erro ao buscar produto:", error);
        this.formData.nomeProduto = "Erro no Banco";
      }
    },

    async buscarTecnico(valor, index) {
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.$set(this.formData.tecnicos[index], 'nome', '');
        this.$set(this.formData.tecnicos[index], 'idtecnico', '');
        return;
      }
      
      try {
        let tecnico = await db.vendedor.where('vencodigo').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('vencodigo').equals(String(idNum)).first();

        if (tecnico) {
          this.$set(this.formData.tecnicos[index], 'nome', tecnico.vennome || tecnico.nome || tecnico.descricao);
          this.$set(this.formData.tecnicos[index], 'idtecnico', tecnico.venidnuvem);
          this.$set(this.formData.tecnicos[index], 'codTecnico', tecnico.vencodigo);
        } else {
          this.$set(this.formData.tecnicos[index], 'nome', 'Técnico não encontrado');
          this.$set(this.formData.tecnicos[index], 'idtecnico', '');
        }
      } catch (error) {
        console.error("Erro ao buscar técnico:", error);
        this.$set(this.formData.tecnicos[index], 'nome', 'Erro no Banco');
      }
    },

    async buscarTecnicoRetirouPeca(valor) {
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.formData.nomeTecnicoRetirouPeca = '';
        this.formData.idTecnicoRetirouPeca = '';
        return;
      }
      
      try {
        let tecnico = await db.vendedor.where('vencodigo').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('vencodigo').equals(String(idNum)).first();

        if (tecnico) {
          this.formData.nomeTecnicoRetirouPeca = tecnico.vennome || tecnico.nome || tecnico.descricao;
          this.formData.idTecnicoRetirouPeca = tecnico.venidnuvem;
          this.formData.codTecnicoRetirouPeca = tecnico.vencodigo;
        } else {
          this.formData.nomeTecnicoRetirouPeca = 'Técnico não encontrado';
          this.formData.idTecnicoRetirouPeca = '';
        }
      } catch (error) {
        console.error("Erro ao buscar técnico que retirou a peça:", error);
        this.formData.nomeTecnicoRetirouPeca = 'Erro no Banco';
      }
    },

    onTecnicoRetirouPecaInput(valor) {
      if (!valor) {
        this.formData.nomeTecnicoRetirouPeca = '';
        this.formData.idTecnicoRetirouPeca = '';
        return;
      }

      clearTimeout(this.debounceTecnicoRetirouPeca);
      this.debounceTecnicoRetirouPeca = setTimeout(() => {
        this.buscarTecnicoRetirouPeca(valor);
      }, 400);
    },

    async salvar() {
      try {
        this.camposInvalidos = [];

        if (!this.formData.idProduto || 
            !this.formData.nomeProduto || 
            ['Produto não encontrado', 'Erro no Banco'].includes(this.formData.nomeProduto)) {
          this.camposInvalidos.push('O Produto não foi informado ou o código é inválido.');
        }

        const qtd = parseFloat(this.formData.quantidadeProduto) || 0;
        if (qtd <= 0) {
          this.camposInvalidos.push('A Quantidade deve ser maior que zero.');
        }

        if (this.exibirSecaoTecnicos) {
          const temTecnicoInvalido = this.formData.tecnicos.some(t => 
            t.codTecnico && ['Técnico não encontrado', 'Erro no Banco'].includes(t.nome)
          );
          if (temTecnicoInvalido) {
            this.camposInvalidos.push('Um ou mais Técnicos informados contêm código inválido.');
          }
        }

        if (this.exibirSecaoTecnicoRetirouPeca) {
          if (!this.formData.idTecnicoRetirouPeca || 
              !this.formData.nomeTecnicoRetirouPeca || 
              ['Técnico não encontrado', 'Erro no Banco'].includes(this.formData.nomeTecnicoRetirouPeca)) {
            this.camposInvalidos.push('O Técnico que retirou a peça não foi informado ou o código é inválido.');
          }
        }

        if (this.camposInvalidos.length > 0) {
          this.dialogValidacao = true;
          return;
        }

        if (!this.prilinkpedidoitem) {
          this.prilinkpedidoitem = this.gerarUUID();
        }

        const obterIdTecnico = (index) => {
          const tecnico = this.formData.tecnicos[index];
          if (tecnico && tecnico.idtecnico !== '' && tecnico.idtecnico !== null && tecnico.idtecnico !== undefined) {
            const idConvertido = parseInt(tecnico.idtecnico, 10);
            return isNaN(idConvertido) ? null : idConvertido;
          }
          return null;
        };

        const obterValorTecnico = (index) => {
          const tecnico = this.formData.tecnicos[index];
          if (tecnico && tecnico.valor !== '' && tecnico.valor !== null && !isNaN(tecnico.valor)) {
            return parseFloat(tecnico.valor);
          }
          return null;
        };

        const idUsuarioNuvem = sessionStorage.getItem(USER_STORAGE.useidnuvem);

        const dadosParaSalvar = {
          prilinkpedidoitem: this.prilinkpedidoitem,
          prinumeroos: this.formData.nroOS,
          priidproduto: parseInt(this.formData.idProduto) || null,
          priquantidade: parseFloat(this.formData.quantidadeProduto) || 1,
          pridescricao: this.formData.nomeProduto,

          priidusuario: idUsuarioNuvem ? parseInt(idUsuarioNuvem) : null,

          priidgrupo: this.formData.idGrupo || null,

          pridatatransmissao: '',
          
          privalor: this.formData.precoProduto,
          pritotal: this.formData.totalProduto,
          
          pritecnico: this.exibirSecaoTecnicos ? obterIdTecnico(0) : null,
          pritecnico2: this.exibirSecaoTecnicos ? obterIdTecnico(1) : null,
          pritecnico3: this.exibirSecaoTecnicos ? obterIdTecnico(2) : null,
          pritecnicoretiroupeca: this.exibirSecaoTecnicoRetirouPeca && this.formData.idTecnicoRetirouPeca ? parseInt(this.formData.idTecnicoRetirouPeca) : null,

          privalortecnico: this.exibirSecaoTecnicos ? obterValorTecnico(0) : null,
          privalortecnico2: this.exibirSecaoTecnicos ? obterValorTecnico(1) : null,
          privalortecnico3: this.exibirSecaoTecnicos ? obterValorTecnico(2) : null,
          
          priobservacao: this.formData.defeitoApresentado,
        };

        const dataLocalCorrigida = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, -1);

        if (this.pedidoDexieId) {
          dadosParaSalvar.pridataalteracao = dataLocalCorrigida; 
          await db.prestacaoservicoitem.update(this.pedidoDexieId, dadosParaSalvar);
        } else {
          let itensExistentes = [];
          try {
            itensExistentes = await db.prestacaoservicoitem
              .where('prilinkpedidoitem')
              .equals(this.prilinkpedidoitem)
              .toArray();
          } catch(e) {
            itensExistentes = await db.prestacaoservicoitem
              .filter(i => i.prilinkpedidoitem === this.prilinkpedidoitem)
              .toArray();
          }

          const maiorOrdem = itensExistentes.reduce((max, item) => {
            return Math.max(max, item.priordem);
          }, 0);

          dadosParaSalvar.priordem = maiorOrdem + 1;

          dadosParaSalvar.pridatainclusao = dataLocalCorrigida; 

          await db.prestacaoservicoitem.add(dadosParaSalvar);
        }

        this.$router.back(); 
        
      } catch (error) {
        console.error("Erro ao salvar:", error);
      }
    },

    excluir() {
      if (!this.pedidoDexieId) return;
      this.dialogExclusao = true;
    },

    async confirmarExclusao() {
      try {
        await db.prestacaoservicoitem.delete(this.pedidoDexieId);
        this.dialogExclusao = false;
        this.$router.back();
      } catch (error) {
        console.error('Erro ao excluir em prestacaoservicoitem:', error);
        alert('Erro ao tentar excluir o item.');
        this.dialogExclusao = false;
      }
    },

    cancelar() {
      this.$router.back();
    },

    async verificarRetornoPesquisa() {
      const estadoSalvo = sessionStorage.getItem('osEmEdicaoitem');
      let indexTecnicoAtual = null;

      if (estadoSalvo) {
        const estado = JSON.parse(estadoSalvo);
        this.formData = Object.assign({}, this.formData, estado.formData);
        
        if (estado.prilinkpedidoitem) {
          this.prilinkpedidoitem = estado.prilinkpedidoitem;
        }

        if (estado.pedidoDexieId) {
          this.pedidoDexieId = estado.pedidoDexieId;
        }

        if (estado.priidnuvem) {
          this.priidnuvem = estado.priidnuvem;
        }

        indexTecnicoAtual = estado.indexTecnicoAtual;
        sessionStorage.removeItem('osEmEdicaoitem');
      }

      const retorno = sessionStorage.getItem('pesquisaResultado');
      if (retorno) {
        try {
          const res = JSON.parse(retorno);
          
          if (res.tipo === 'Produto') {
            this.veioDaPesquisa = true;
            this.formData.idProduto = res.id; 
            this.formData.nomeProduto = res.nome || res.descricao; 

            if (!this.formData.quantidadeProduto || this.formData.quantidadeProduto == 0) {
              this.formData.quantidadeProduto = 1;
            }
            
          } 
          else if (res.tipo === 'Tecnico' && indexTecnicoAtual !== null) {
            await this.buscarTecnicoPorIdNuvem(res.codigo || res.id, indexTecnicoAtual);
          }
          else if (res.tipo === 'TecnicoRetirouPeca') {
            await this.buscarTecnicoRetirouPecaPorIdNuvem(res.codigo || res.id);
          }
          
          sessionStorage.removeItem('pesquisaResultado');
        } catch (error) {
          console.error('Erro ao ler sessionStorage:', error);
        }
      }
      
      const retornoProdutoCompleto = sessionStorage.getItem('produto_selecionado_retorno');
      if (retornoProdutoCompleto) {
        try {
          const prodCompleto = JSON.parse(retornoProdutoCompleto);
          this.formData.idGrupo = prodCompleto.idgrupo || prodCompleto.proidgrupo || null;
          
          const preco = prodCompleto.provalor || prodCompleto.preco || prodCompleto.propreco || 0;
          if (preco) {
            this.formData.precoProduto = Number(preco);
          }
          
          sessionStorage.removeItem('produto_selecionado_retorno');
        } catch (error) {
          console.error('Erro ao ler produto_selecionado_retorno:', error);
        }
      }

      if (this.formData.idProduto) {
        await this.verificarSeEhServico(this.formData.idProduto, this.formData.idGrupo);
      }
    },
    
    formatarValor(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    permitirApenasNumeros(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode === 0 || charCode === 8 || charCode === 9 || charCode === 13 || charCode === 27 || charCode === 46) {
        return;
      }
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },

    pesquisarProduto() {
      sessionStorage.setItem('osEmEdicaoitem', JSON.stringify({ 
        formData: this.formData,
        prilinkpedidoitem: this.prilinkpedidoitem,
        pedidoDexieId: this.pedidoDexieId,
        priidnuvem: this.priidnuvem
      }));
      this.$router.push({ name: 'produto', query: { tipo: 'Produto' } });
    },

    pesquisarTecnico(index) {
      sessionStorage.setItem('osEmEdicaoitem', JSON.stringify({ 
        formData: this.formData,
        prilinkpedidoitem: this.prilinkpedidoitem,
        indexTecnicoAtual: index,
        pedidoDexieId: this.pedidoDexieId,
        priidnuvem: this.priidnuvem
      }));
      
      this.$router.push({ name: 'vendedor', query: { tipo: 'Tecnico' } });
    },

    pesquisarTecnicoRetirouPeca() {
      sessionStorage.setItem('osEmEdicaoitem', JSON.stringify({ 
        formData: this.formData,
        prilinkpedidoitem: this.prilinkpedidoitem,
        pedidoDexieId: this.pedidoDexieId,
        priidnuvem: this.priidnuvem
      }));
      
      this.$router.push({ name: 'vendedor', query: { tipo: 'TecnicoRetirouPeca' } });
    },

    adicionarTecnico() {
      if (this.formData.tecnicos.length < 3) {
        this.formData.tecnicos.push({ codTecnico: '', idtecnico: '', nome: '', valor: '' });
      }
    },

    removerTecnico(index) {
      if (this.formData.tecnicos.length > 1) {
        this.formData.tecnicos.splice(index, 1);
      }
    },

    formatarMoedaArray(valor) {
      const v = parseFloat(valor) || 0;
      return v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    atualizarValorTecnico(novoValor, index) {
      const apenasNumeros = novoValor.toString().replace(/\D/g, '');
      const valorReal = apenasNumeros ? (parseFloat(apenasNumeros) / 100) : 0;
      this.$set(this.formData.tecnicos[index], 'valor', valorReal); 
    },

    calcularTotal() {
      const qtd = parseFloat(this.formData.quantidadeProduto) || 0;
      const preco = parseFloat(this.formData.precoProduto) || 0; 
      
      this.formData.totalProduto = qtd * preco; 
    },

    limparZeroQuantidade() {
      if (this.formData.quantidadeProduto === 0 || this.formData.quantidadeProduto === '0') {
        this.formData.quantidadeProduto = '';
      }
    },

    restaurarZeroQuantidade() {
      if (!this.formData.quantidadeProduto || this.formData.quantidadeProduto === '') {
        this.formData.quantidadeProduto = 0;
      }
    },

    gerarUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    async buscarTecnicoPorIdNuvem(idNuvem, index) {
      if (!idNuvem) return;
      const idNum = parseInt(idNuvem);
      
      try {
        let tecnico = await db.vendedor.where('venidnuvem').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('venidnuvem').equals(String(idNum)).first();

        if (tecnico) {
          this.$set(this.formData.tecnicos, index, {
            ...this.formData.tecnicos[index],
            idtecnico: tecnico.venidnuvem,
            codTecnico: tecnico.vencodigo,
            nome: tecnico.vennome || tecnico.nome || tecnico.descricao
          });
        }
      } catch (error) {
        console.error("Erro ao buscar técnico por ID Nuvem:", error);
      }
    },

    async buscarTecnicoRetirouPecaPorIdNuvem(idNuvem) {
      if (!idNuvem) return;
      const idNum = parseInt(idNuvem);
      
      try {
        let tecnico = await db.vendedor.where('venidnuvem').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('venidnuvem').equals(String(idNum)).first();
        if (!tecnico) tecnico = await db.vendedor.where('vencodigo').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('vencodigo').equals(String(idNum)).first();

        if (tecnico) {
          this.formData.idTecnicoRetirouPeca = tecnico.venidnuvem;
          this.formData.codTecnicoRetirouPeca = tecnico.vencodigo;
          this.formData.nomeTecnicoRetirouPeca = tecnico.vennome || tecnico.nome || tecnico.descricao;
        }
      } catch (error) {
        console.error("Erro ao buscar técnico que retirou a peça por ID Nuvem:", error);
      }
    },

    async carregarItemParaEdicao(id) {
      try {
        const idNumerico = parseInt(id);
        const itemSalvo = await db.prestacaoservicoitem.get(idNumerico);

        if (!itemSalvo) {
          console.error('Item não encontrado no banco de dados.');
          return;
        }

        this.pedidoDexieId = itemSalvo.id || idNumerico;
        this.prilinkpedidoitem = itemSalvo.prilinkpedidoitem;

        this.priidnuvem = itemSalvo.priidnuvem || null;

        this.formData.idProduto = itemSalvo.priidproduto || null;
        this.formData.nomeProduto = itemSalvo.pridescricao || '';
        this.formData.quantidadeProduto = itemSalvo.priquantidade || 0;
        this.formData.precoProduto = itemSalvo.privalor || 0;
        this.formData.totalProduto = itemSalvo.pritotal || 0;
        this.formData.defeitoApresentado = itemSalvo.priobservacao || '';
        this.formData.idGrupo = itemSalvo.priidgrupo || null;

        await this.verificarSeEhServico(this.formData.idProduto, this.formData.idGrupo);

        this.formData.idTecnicoRetirouPeca = itemSalvo.pritecnicoretiroupeca || '';
        if (this.formData.idTecnicoRetirouPeca) {
          await this.buscarTecnicoRetirouPecaPorIdNuvem(this.formData.idTecnicoRetirouPeca);
        }

        const tecnicosArray = [];

        if (itemSalvo.pritecnico) {
          tecnicosArray.push({ 
            idtecnico: itemSalvo.pritecnico, 
            codTecnico: '',
            nome: '', 
            valor: itemSalvo.privalortecnico || 0 
          });
        }
        if (itemSalvo.pritecnico2) {
          tecnicosArray.push({ 
            idtecnico: itemSalvo.pritecnico2, 
            codTecnico: '', 
            nome: '', 
            valor: itemSalvo.privalortecnico2 || 0 
          });
        }
        if (itemSalvo.pritecnico3) {
          tecnicosArray.push({ 
            idtecnico: itemSalvo.pritecnico3, 
            codTecnico: '', 
            nome: '', 
            valor: itemSalvo.privalortecnico3 || 0 
          });
        }

        if (tecnicosArray.length === 0) {
          tecnicosArray.push({ codTecnico: '', idtecnico: '', nome: '', valor: '' });
        }

        this.formData.tecnicos = tecnicosArray;
        this.ajustarQuantidadeTecnicos();

        for (let i = 0; i < this.formData.tecnicos.length; i++) {
          if (this.formData.tecnicos[i].idtecnico) {
            await this.buscarTecnicoPorIdNuvem(this.formData.tecnicos[i].idtecnico, i);
          }
        }

      } catch (error) {
        console.error("Erro ao carregar item para edição:", error);
      }
    },

  },

  async created() {
    const idVinculo = this.$route.query.prslinkpedidoitem;
    if (idVinculo) {
      this.prilinkpedidoitem = idVinculo;
    }

    const idItem = this.$route.query.idItem;
    
    const temEstadoSalvo = sessionStorage.getItem('osEmEdicaoitem') !== null;
    const temResultadoPesquisa = sessionStorage.getItem('pesquisaResultado') !== null;

    if (idItem && !temEstadoSalvo && !temResultadoPesquisa) {
      await this.carregarItemParaEdicao(idItem);
    }
  },

  watch: {
    'formData.idProduto'(novo) {
      if (!novo) {
        this.formData.nomeProduto = '';
        this.formData.idGrupo = null;
        this.isServico = false;
        return; 
      }

      if (this.veioDaPesquisa) {
        this.veioDaPesquisa = false;
        this.verificarSeEhServico(novo, this.formData.idGrupo);
        return;
      }

      clearTimeout(this.debounceProduto);
      this.debounceProduto = setTimeout(() => {
        this.buscarProduto(novo);
      }, 400); 
    },
    
    'formData.quantidadeProduto': function() { this.calcularTotal() },
    'formData.precoProduto': function() { this.calcularTotal() },
    qtdeTecnicosOS() {
      this.ajustarQuantidadeTecnicos();
    }
  }
}
</script>

<style scoped>
.formulario-wrapper {
  background-color: #f5f5f5;
  padding: 32px 16px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.lista-itens-container {
  max-height: 400px; 
  border: 1px solid #eee;
  border-radius: 4px;
}

.lista-itens-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

.lista-itens-container ::v-deep .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}

.v-cardt{
  padding-top: 5px;
}

.v-card {
  max-width: 900px;
  width: 100%;
}

.v-subheader {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 8px;
}

.v-form .v-row {
  margin-bottom: 4px;
}

.col-codigo {
  flex: 0 0 25%;
  max-width: 25%;
}
.col-botao {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}
.col-descricao {
  padding-left: 18px;
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.switch-pedido-ativo ::v-deep .v-input--switch__track {
  color: #9dafd1 !important;
  opacity: 0.6;
}

.switch-pedido-ativo ::v-deep .v-input--switch__thumb {
  color: #4c6faf !important;
}

.switch-pedido-ativo ::v-deep .v-input--selection-controls__ripple {
  color: #728ec2 !important;
}

@media (min-width: 600px) {
  .col-codigo {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-botao {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-descricao {
    margin-left: 0;
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
}

.total-vermelho ::v-deep input {
  color: red !important;
  font-weight: bold;
}

::v-deep .v-text-field--outlined .v-input__control .v-input__slot {
  min-height: 40px !important;
}

.divisor-secao {
  border-top: 1px solid #5a5a5a !important;
  border-color: #5a5a5a !important;
  opacity: 0.95;
}
</style>